import { Realtime } from 'ably';
import { channel } from 'redux-saga';

export const AblyChannelSingleton = (() => {
  let instance;
  function createInstance(token, channelName, generalAction, specificNotifications) {
    const connectionStatusChannel = channel();
    const realtime = new Realtime({ token, closeOnUnload: true });
    const ablyChannel = realtime.channels.get(channelName);

    ablyChannel.subscribe(msg => {
      connectionStatusChannel.put(generalAction(msg));
    });

    if (ablyChannel.state === 'attaching' || ablyChannel.state === 'initialized') {
      console.log(`channel: ${channelName}, current state: ${ablyChannel.state}`);
      setTimeout(() => {
        console.log(`setTimeout channel: ${channelName}, current state: ${ablyChannel.state}`);
        if (ablyChannel.state === 'attaching') {
          AblyChannelSingleton.removeInstance(channelName, token);
          return createInstance(token, channelName, generalAction, specificNotifications);
        }
      }, 4000);
    }

    ablyChannel.on('attached', stateChange => {
      console.log('channel attached');
      console.log(stateChange);
    });

    ablyChannel.on('detached', stateChange => {
      console.log('channel detached');
      console.log(stateChange);
    });

    ablyChannel.on('suspended', stateChange => {
      console.log('channel suspended');
      console.log(stateChange);
    });

    ablyChannel.on('failed', stateChange => {
      console.log('channel failed');
      console.log(stateChange);
    });

    specificNotifications.forEach(notification => {
      ablyChannel.subscribe(notification.events, msg => {
        if (
          notification.events &&
          notification.events.length > 0 &&
          notification.events.indexOf(msg.name) >= 0
        ) {
          connectionStatusChannel.put(notification.action(msg));
        }
      });
    });
    return connectionStatusChannel;
  }

  return {
    getInstance: (token, channelName, generalAction, specificNotifications) => {
      if (!instance || instance.length === 0) {
        instance = [
          {
            channelName,
            channel: createInstance(token, channelName, generalAction, specificNotifications)
          }
        ];
      } else if (
        instance.length > 0 &&
        instance.filter(x => x.channelName === channelName).length === 0
      ) {
        instance.push({
          channelName,
          channel: createInstance(token, channelName, generalAction, specificNotifications)
        });
      }
      return instance.filter(x => x.channelName === channelName)[0].channel;
    },
    removeInstance: (channelName, token) => {
      if (
        instance &&
        instance.length > 0 &&
        instance.filter(x => x.channelName === channelName).length > 0
      ) {
        const realtime = new Realtime({ token, closeOnUnload: true });
        const ablyChannel = realtime.channels.get(channelName);
        ablyChannel.unsubscribe();
        instance = instance.filter(x => x.channelName !== channelName);
      }
    }
  };
})();
